import React from 'react'
import brandConfig from "../../../brandConfig";

function Footer() {
  return (
    <div className="border-top ms-auto">
    <footer className="text-sm z-20 flex items-center justify-end h-8 pt-1 text-black pr-4">
      <span className="text-xs font-medium text-white">
        © {new Date().getFullYear()} {brandConfig.footerText} - All Rights Reserved
      </span>
    </footer>
  </div>
  )
}

export default Footer